import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative h-[450px] lg:h-165',
    breadcrumbsWrapper:
      'absolute top-25 z-10 container w-full lg:top-46.5 lg:right-0 lg:left-0 lg:mx-auto lg:max-w-360',
    breadcrumbs: '',
    link: 'hover:bg-blue-dark flex flex-none cursor-pointer flex-nowrap items-center gap-4 rounded-[100px] bg-white/80 py-1 pr-3 pl-1 backdrop-blur-[20px] hover:text-white md:pr-10',
    linkLabel: 'inline-flex text-sm font-semibold whitespace-nowrap md:text-xl',
    linkBlock: 'flex-none',
    linkWrap:
      'scrollbar-hidden relative flex w-full gap-1 overflow-x-auto pr-4 pl-4 sm:justify-center lg:snap-none lg:gap-2',
    linkImage: 'h-12 w-12 rounded-full md:h-20 md:w-20',
    video: 'absolute top-0 left-0 h-full w-full object-cover',
    brandLogo: 'mx-auto mb-12.75 h-auto w-66 md:mb-25 md:w-88',
    wrap: 'relative z-1 m-auto flex h-[450px] w-full flex-col justify-end pb-4 lg:h-165 lg:pb-20'
  }
});
